import React from 'react';
import { Box, Typography } from '@mui/material';

const EmptyState = ({
  icon,
  title = 'No data available',
  description = 'Try adjusting your filters or come back later.',
  action,
}) => {
  return (
    <Box
      sx={{
        py: 4,
        px: 2,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        gap: 1.25,
      }}
    >
      {icon && (
        <Box
          sx={{
            width: 60,
            height: 60,
            borderRadius: '50%',
            backgroundColor: 'rgba(4, 88, 100, 0.08)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'var(--primary)',
            mb: 0.5,
          }}
        >
          {icon}
        </Box>
      )}
      <Typography variant="h6" sx={{ fontWeight: 700, color: 'var(--text-primary)', fontSize: '1.05rem' }}>
        {title}
      </Typography>
      <Typography variant="body2" sx={{ color: 'var(--text-secondary, #64748b)', maxWidth: 420, lineHeight: 1.5 }}>
        {description}
      </Typography>
      {action ? <Box sx={{ mt: 1.5 }}>{action}</Box> : null}
    </Box>
  );
};

export default EmptyState;
